<template>
  <div>
    <div v-if="isIvrActive">
      <div v-if="canViewLead">
        <component
          v-if="view != null"
          :is="rolComponent[view].component"
          :detalles="detalles"
        ></component>
      </div>
      <div v-else>
        <v-alert type="info" class="mt-4">
          <template v-slot:prepend>
            <v-progress-circular
              indeterminate
              color="#fff"
            ></v-progress-circular>
          </template>
          <div class="text-h5 ml-5">
            {{ loadingText }}
          </div>
        </v-alert>
      </div>
    </div>
    <div v-else>
      <component
        v-if="view != null"
        :is="rolComponent[view].component"
        :detalles="detalles"
      ></component>
    </div>
  </div>
</template>

<script>
import DetallesLeadAdmin from "./admin/leads/DetallesLeads.vue";
import DetallesLeadsAgent from "./agentes/leads/DetallesLeads.vue";
import { mapMutations, mapActions, mapState } from "vuex";
import callState from "@/mixins/callState.mixin";
import { reAssignLeadByUuid } from "@/services/leadService";

export default {
  name: "bradescard.leads",
  props: ["detalles"],
  mixins: [callState],
  data() {
    return {
      roles: JSON.parse(localStorage.getItem("roles")),
      view: null,
      rolComponent: {
        admin: {
          component: DetallesLeadAdmin,
        },
        agente: {
          component: DetallesLeadsAgent,
        },
      },

      loadingReassign: false,
      leadReassigned: false,
    };
  },

  computed: {
    ...mapState("leads", ["lead"]),

    isIvrActive() {
      return this.$store.getters["callState/isIvrActive"];
    },

    isIvrLoaded() {
      return this.$store.getters["callState/isIvrLoaded"];
    },

    loadingText() {
      if (this.isIvrActive && !this.isIvrLoaded) {
        return "Cargando estado de llamada...";
      }
      if (this.isIvrActive && this.loadingReassign)
        return "Reasignando lead...";
      return "";
    },

    leadUuid() {
      return this.$route.params.uuid;
    },

    canViewLead() {
      if (!this.isIvrActive) return true;
      return this.isIvrLoaded && this.lead !== "" && this.lead.uuid === this.$route.params.uuid;
    },
  },

  watch: {
    lead(v) {
      if (v === "") this.reAssignLead();
    },

    async "$route.params.uuid"(newUuid, oldUuid) {
      if (newUuid !== oldUuid) {
        this.leadReassigned = false;
        await this.LoadDetalleLead(newUuid);
      }
    },
  },

  async beforeMount() {
    this.getRole();
    await this.LoadDetalleLead(this.$route.params.uuid);
    if (this.view === "agente") this.loadIvrScript();
    this.obtenerProducto();
  },

  methods: {
    ...mapMutations("polizas", ["setPolizas"]),
    ...mapMutations("llamadas", ["setLlamadas"]),
    ...mapActions("polizas", ["obtenerProducto"]),
    ...mapActions("leads", ["LoadDetalleLead"]),

    getRole() {
      var roles = [];
      this.roles.forEach((element) => {
        roles.push(element.rol);
      });

      const rolesAdmin = [
        "ADMIN",
        "ADMINCC",
        "MANAGERCC",
        "DIRECTOR",
        "FINANZAS",
        "OPERACIONES",
        "OPERADOR",
        "COORDINADOR",
        "SUPERVISOR",
        "GERENTE",
        "OPERADORSERVICIOS",
      ];
      const rolesAgents = ["AGENTCC", "AGENTCCELITE"];
      roles.forEach((element) => {
        if (rolesAdmin.includes(element)) {
          this.view = "admin";
        }
        if (rolesAgents.includes(element)) {
          this.view = "agente";
        }
      });
    },

    reAssignLead() {
      this.loadingReassign = true;
      reAssignLeadByUuid(this.leadUuid)
        .then(() => {
          this.leadReassigned = true;
          this.LoadDetalleLead(this.leadUuid);
        })
        .catch((error) => {
          console.error("Error reassigning lead:", error);
        })
        .finally(() => {
          this.loadingReassign = false;
        });
    },
  },

  destroyed() {
    this.setPolizas([]);
    this.setLlamadas([]);
  },
};
</script>

<style></style>
